<template>
  <div id="4_main">

  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        
      }
    },
    watch: {
      
    },
    methods: {

    },
    computed: {
      
    },
    created: function () {

    },
  }
</script>